import { Navigate, type RouteObject } from 'react-router-dom-v6'
import AppLayout from './components/AppLayout'
import PagePlaceholder from './components/PagePlaceholder'
import RouteError from './components/RouteError'
import { CustomersSearch } from './features/customers'
import {
  TrackingObjects,
  TrackerActivation,
  TrackingObjectStatus,
  ConfigLayout,
  DigitalInputsConfig,
  AnalogInputsConfig,
  SensorsConfig,
  TrackingObjectTemplateConfig,
  MoveTrackingObject,
} from './features/trackingObjects'
import { ConfigTemplatesList, RegisterConfigTemplate, EditConfigTemplate } from './features/configTemplates'
import { NetworksList, RegisterNetwork, UpdateNetwork } from './features/networks'

// URL map from the mobile-app rewrite plan (plan.md section 3.2). Screens are
// placeholders; feature phases replace them route by route.
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <CustomersSearch /> },
      {
        path: 'customers/:id/tracking-objects',
        children: [
          { index: true, element: <TrackingObjects /> },
          { path: 'activate', element: <TrackerActivation /> },
          {
            path: ':tid',
            children: [
              { path: 'status', element: <TrackingObjectStatus /> },
              { path: 'move', element: <MoveTrackingObject /> },
              {
                path: 'config',
                element: <ConfigLayout />,
                children: [
                  { index: true, element: <Navigate to="analogs" replace /> },
                  { path: 'analogs', element: <AnalogInputsConfig /> },
                  { path: 'digitals', element: <DigitalInputsConfig /> },
                  { path: 'sensors', element: <SensorsConfig /> },
                ],
              },
              // Apply-template is a standalone screen, not a config tab.
              { path: 'config/template', element: <TrackingObjectTemplateConfig /> },
            ],
          },
        ],
      },
      {
        path: 'config-templates',
        children: [
          { index: true, element: <ConfigTemplatesList /> },
          { path: 'new', element: <RegisterConfigTemplate /> },
          { path: ':id/edit', element: <EditConfigTemplate /> },
        ],
      },
      {
        path: 'networks',
        children: [
          { index: true, element: <NetworksList /> },
          { path: 'new', element: <RegisterNetwork /> },
          { path: ':id/edit', element: <UpdateNetwork /> },
        ],
      },
      { path: '*', element: <PagePlaceholder title="Page not found" /> },
    ],
  },
]
